import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { DirectoryTagView } from '../directory-tags.api';

interface RowActions {
  onEdit: (tag: DirectoryTagView) => void;
  onDeactivate: (tag: DirectoryTagView) => Promise<void>;
  onReactivate: (tag: DirectoryTagView) => Promise<void>;
}

/** Name and status; the actions column is left out without `service.manage`, since `maintenance.view` alone reads the catalogue. */
export function buildDirectoryTagColumns(actions?: RowActions): TableColumnsType<DirectoryTagView> {
  const columns: TableColumnsType<DirectoryTagView> = [
    { title: 'Name', dataIndex: 'name' },
    {
      title: 'Status',
      dataIndex: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
  ];
  if (actions) columns.push({ title: '', key: 'actions', render: (_, row) => <CatalogueRowActions row={row} {...actions} /> });
  return columns;
}
